import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { Container } from "./style";
import "./style.scss";

export default function Phone(props) {
	const { onChange, onBlur, onFocus, numberPhone, error = false } = props;

	return (
		<Container error={error}>
			<PhoneInput
				defaultCountry="br"
				country={"br"}
				masks={{ br: "(..) .....-...." }}
				preferredCountries={["br"]}
				placeholder={"Digite seu telefone"}
				value={numberPhone}
				onChange={(param) => onChange(param)}
				onBlur={(param) => (onBlur ? onBlur(param) : null)}
				onFocus={(param) => (onFocus ? onFocus(param) : null)}
				countryCodeEditable={false}
				dropdownStyle={{
					background: "#353546",
				}}
			/>
		</Container>
	);
}
